import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      order: -1,
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      height: 'inherit',
    },
  },
}));

const SideBar: React.FC<React.PropsWithChildren<{ children: React.ReactNode }>> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Grid classes={classes} container direction="column" wrap="nowrap" item xs="auto" md={4} sx={{ width: '100%' }}>
      {children}
    </Grid>
  );
};

export default SideBar;
